import { dotStyle } from "./index.css"
import React from "react"

export function NotificationDot(): React.JSX.Element {
  return (
    <div>
      <span className={dotStyle} />
    </div>
  )
}
